import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const SafetyKitIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M6.75013 2.5C6.61206 2.5 6.50013 2.61193 6.50013 2.75V4H5.00013V2.75C5.00013 1.7835 5.78363 1 6.75013 1H9.25C10.2165 1 11 1.7835 11 2.75V4H9.5V2.75C9.5 2.61193 9.38807 2.5 9.25 2.5H6.75013Z"
		></path>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M1 7.25C1 6.00736 2.00736 5 3.25 5H12.75C13.9926 5 15 6.00736 15 7.25V12.75C15 13.9926 13.9926 15 12.75 15H3.25C2.00736 15 1 13.9926 1 12.75V7.25ZM7 7.8C7 7.51997 7 7.37996 7.0545 7.273C7.10243 7.17892 7.17892 7.10243 7.273 7.0545C7.37996 7 7.51997 7 7.8 7H8.2C8.48003 7 8.62004 7 8.727 7.0545C8.82108 7.10243 8.89757 7.17892 8.9455 7.273C9 7.37996 9 7.51997 9 7.8V9H10.2C10.48 9 10.62 9 10.727 9.0545C10.8211 9.10243 10.8976 9.17892 10.9455 9.273C11 9.37996 11 9.51997 11 9.8V10.2C11 10.48 11 10.62 10.9455 10.727C10.8976 10.8211 10.8211 10.8976 10.727 10.9455C10.62 11 10.48 11 10.2 11H9V12.2C9 12.48 9 12.62 8.9455 12.727C8.89757 12.8211 8.82108 12.8976 8.727 12.9455C8.62004 13 8.48003 13 8.2 13H7.8C7.51997 13 7.37996 13 7.273 12.9455C7.17892 12.8976 7.10243 12.8211 7.0545 12.727C7 12.62 7 12.48 7 12.2V11H5.8C5.51997 11 5.37996 11 5.273 10.9455C5.17892 10.8976 5.10243 10.8211 5.0545 10.727C5 10.62 5 10.48 5 10.2V9.8C5 9.51997 5 9.37996 5.0545 9.273C5.10243 9.17892 5.17892 9.10243 5.273 9.0545C5.37996 9 5.51997 9 5.8 9H7V7.8Z"
		></path>
	</svg>
))
